// extracted by mini-css-extract-plugin
export default {"container":"HL7FiltersPage_container__0UNw8","header":"HL7FiltersPage_header__DcWW7","title":"HL7FiltersPage_title__HwrMr"};